var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader"},[_c('div',{staticClass:"preloader__content"},[_c('p',{directives:[{name:"text-animation",rawName:"v-text-animation"}]},[_vm._v("Just a moment")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }